import Modal from "../../../components/common/Modal";
import Button from "../../../components/Button";
import { copyQuotation } from "../../../api/quotation";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const CopyQuotationPopup = ({
  quotationId,
  onClose,
}: {
  quotationId?: string;
  onClose?: () => void;
}) => {
  const [copyQuotationLoading, setCopyQuotationLoading] = useState(false);
  const [copyQuotationData, setCopyQuotationData] = useState<any>(null);
  const [openCopyQuotationSuccess, setOpenCopyQuotationSuccess] =
    useState(false);

  const navigate = useNavigate();

  async function copyQuotationHandler() {
    setCopyQuotationLoading(true);
    try {
      const response = await copyQuotation(quotationId);
      setCopyQuotationData(response?.data);
      setOpenCopyQuotationSuccess(true);
      toast.success("Quotation copied successfully");
    } catch (error) {
      console.error("Error copying quotation: ", error);
      toast.error("Failed to copy quotation");
    } finally {
      setCopyQuotationLoading(false);
    }
  }

  return (
    <>
      {!openCopyQuotationSuccess && (
        <Modal
          headerClass="mt-4 mb-1"
          header="Are you sure you want to copy this quotation? This will create a new
          quotation with the same details as the original quotation."
          handleCancel={onClose}
          clickOutsideToClose
          footer={
            <div className="flex gap-4">
              <Button
                label="Copy"
                variant="primary"
                onClick={() => {
                  copyQuotationHandler();
                }}
                disabled={copyQuotationLoading}
              />
              <Button label="Cancel" variant="secondary" onClick={onClose} />
            </div>
          }
        >
          <div></div>
        </Modal>
      )}

      {openCopyQuotationSuccess && (
        <Modal
          clickOutsideToClose
          handleCancel={onClose}
          footer={
            <div className="flex gap-4">
              <Button
                label="Go Back"
                variant="primary"
                onClick={() => {
                  setOpenCopyQuotationSuccess(false);
                }}
                disabled={copyQuotationLoading}
              />
              <Button
                label={`Open Quotation #${copyQuotationData?.num}`}
                variant="secondary"
                onClick={() => {
                  navigate(`/quotations/${copyQuotationData?.id}`);
                }}
                disabled={copyQuotationLoading}
              />
            </div>
          }
        >
          <div className="my-4 text-base">
            Your new Quotation &nbsp;
            <span className="font-gilroy-bold">{copyQuotationData?.name}</span>
            &nbsp;
            <span className="font-gilroy-bold">#{copyQuotationData?.num}</span>
            &nbsp; is ready.
          </div>
        </Modal>
      )}
    </>
  );
};

export default CopyQuotationPopup;
